module.exports = __webpack_public_path__ + "img/akgb.2d3d8c42.png";